<template>
    <div style="height:1000px; margin-left: 90px; margin-top: 100px;">
        <v-layout row wrap justify-end style="margin-right:5%">

            <v-btn style="height:50%" class="hidden-xs-only" small @click="LoadGraphic()"
                color="accent">Visualizar</v-btn>

        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 md6>
                <v-select name="yearCommercial" v-bind:label="$t('message.yearCommercial')" v-validate="'required'"
                    :error-messages="errors.collect('yearCommercial')" item-text="Valor" :items="yearCommercialList"
                    v-model="yearComercial" @change="getBusinessLine()"></v-select>
            </v-flex>

            <v-flex xs12 md6>
                <v-select name="typeProduction" v-bind:label="$t('message.typeProduction')" v-validate="'required'"
                    :error-messages="errors.collect('typeProduction')" :items="catalogTypeOfProductionList"
                    item-text="value" v-model="typeProduction"></v-select>
            </v-flex>

            <v-flex xs12 md6>
                <v-select name="startWeek" v-bind:label="$t('message.startWeek')" v-validate="'required'"
                    :error-messages="errors.collect('startWeek')" item-text="Valor" :items="startWeekList"
                    v-model="startWeek"></v-select>
            </v-flex>

            <v-flex xs12 md6>
                <v-select name="endWeek" v-bind:label="$t('message.endWeek')" v-validate="'required'"
                    :error-messages="errors.collect('endWeek')" item-text="Valor" :items="endWeekList"
                    v-model="endWeek"></v-select>
            </v-flex>

            <v-flex xs12 md6>
                <label
                    style="color: rgb(149, 149, 149);!important;font-size: 16px;line-height: 1;min-height: 8px;font-weight: 400;">Sucursales</label>
                <v-radio-group name="sucursal" v-validate="'required'" :error-messages="errors.collect('sucursal')"
                    v-model="sucursal" :mandatory="false">
                    <v-radio label="Todas" value="0"></v-radio>
                    <v-radio label="Sucursal Actual" value="1"></v-radio>
                </v-radio-group>
            </v-flex>
            <v-flex xs12 md6>
                <v-select name="lineBusiness" v-bind:label="$t('message.lineBusiness')" v-validate="'required'"
                    :error-messages="errors.collect('lineBusiness')" :items="catalogTypeOfLineBusiness"
                    item-text="value" v-model="lineBusiness"></v-select>
            </v-flex>
        </v-layout>

        <ChartProduccionPorSemanaComercial :width="1400" :height="550" :dataGrafic="dataGrafic">
        </ChartProduccionPorSemanaComercial>

        <h5>Nota :El presupuesto que se refleja toma en
            cuenta negocios facultativos</h5>
    </div>

</template>
<script>
import { mapGetters } from "vuex";
import ChartProduccionPorSemanaComercial from "./ChartProduccionPorSemanaComercial";
import CatalogServices from "@/services/CatalogsServices";
import CommercialGraphicsServices from "@/services/CommercialGraphicsServices";
import { EventBus } from "@/imports/EventBus";

export default {
    mounted() {
            CatalogServices.getTypeOfProduction()
                .then(response => {

                this.catalogTypeOfProductionList = response.data.data;
            })
            .catch(res => {
                this.catalogTypeOfProductionList = [];
                this.$root.$emit("hideLoading");
                this.$root.$emit("showSnackBar", "Error desconocido", "error");
            });


    },
    components: {
        ChartProduccionPorSemanaComercial


    },
    computed: {
        ...mapGetters(["agency", "userProfile", "agencyId", "agencyName"]),

    },
    methods: {
        getBusinessLine(){
      
      if(this.yearComercial < 2023){
        CatalogServices.getTypeLineBusiness()
      .then(response => {
        if (response.data.error == 0) {
          this.catalogTypeOfLineBusiness = response.data.data;
        } else {
          this.catalogTypeOfLineBusiness = [];

        }


      })
      .catch(res => {
        this.$root.$emit("hideLoading");
        this.$root.$emit("showSnackBar", "Error desconocido", "error");
       
      });

      }else{
        CatalogServices.getLineBusinessByYear()
                    .then((response) => {
                        if (response.data.error == 0) {

                            this.catalogTypeOfLineBusiness = response.data.data;
                            this.catalogTypeOfLineBusiness.unshift({ code: "0", value: "TODOS" });
                        } else {
                            this.catalogTypeOfLineBusiness = [];
                        }
                    })
                    .catch((res) => {
                        this.$root.$emit("showSnackBar", "Error desconocido", "error");
                    });

               
      }
    
    },
        LoadGraphic() {
            this.$validator.validateAll().then(success => {
                if (success) {
                    this.$nextTick(() => {
                        this.GetDataFromApi();
                    });
                    /* this.showGraphic=true
                      this.table1=analysisJSONTest.Data.Tabla1
                    */
                }
            });
        }
        ,
        async getApsInfo(apsId) {

            let idAps = "";
            await CatalogServices.getDataApsInfo()

            .then((response) => {
                idAps = response.data.data.filter(({ codeSiaerp }) => (codeSiaerp == apsId))[0]["code"]
                

            }).catch(()=>{
                this.$root.$emit("hideLoading");
                this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
            })
            if(idAps == "" || idAps == undefined || idAps == null ){
            this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
            this.$root.$emit("hideLoading");
            }

            return idAps;
        },
        async GetDataFromApi() {
            this.$root.$emit(
                "showLoading",
                "Cargando producción por semana de cumplimiento"
            );
            this.broker =await this.getApsInfo(this.userProfile.user_id);

            var model = {
                "Broker":this.broker,
                "AnioComercial": this.yearComercial,
                "TiposProduccion": this.typeProduction,
                "SemanaInicio": this.startWeek,
                "SemanaFin": this.endWeek,
                "Sucursales": this.sucursal == "0" ? "Todas" : this.agencyName,
                "LineaNegocio": this.lineBusiness,

            }


            await CommercialGraphicsServices.getProductionByComercialWeekGraphic(model).then((response) => {
                this.dataGrafic = response.data.data.semanasPorProduccion;



            }).catch(res => {
                this.$root.$emit("hideLoading");
                this.$root.$emit("showSnackBar", "Error desconocido", "error");
            });
            await EventBus.$emit("ChartProduccionPorSemanaComercial");
            this.$root.$emit("hideLoading");




        }
    }
    , data() {
        return {
            dataGrafic: {},
            catalogTypeOfLineBusiness: [],
            catalogTypeOfProductionList: [],
            broker:null,
            yearComercial: null,
            typeProduction: null,
            startWeek: null,
            endWeek: null,
            lineBusiness: null,
            sucursal: null,
            yearCommercialList: [
                "2012",
                "2013",
                "2014",
                "2015",
                "2016",
                "2017",
                "2018",
                "2019",
                "2020",
                "2021",
                "2022",
                "2023",
                "2024",
                "2025",
                "2026",
                "2027",
                "2028",
                "2029",
                "2030",
                "2031",
                "2032",
                "2033",
                "2034",
                "2035",
                "2036",
                "2037",
                "2038",
                "2039",
                "2040",
                "2041",
                "2042",
                "2043",
                "2044",
                "2045",
                "2046",
                "2047",
                "2048",
                "2049",
                "2050"
            ],
            startWeekList: [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23",
                "24",
                "25",
                "26",
                "27",
                "28",
                "29",
                "30",
                "31",
                "32",
                "33",
                "34",
                "35",
                "36",
                "37",
                "38",
                "39",
                "40",
                "41",
                "42",
                "43",
                "44",
                "45",
                "46",
                "47",
                "48",
                "49",
                "51",
                "52"
            ],
            endWeekList: [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23",
                "24",
                "25",
                "26",
                "27",
                "28",
                "29",
                "30",
                "31",
                "32",
                "33",
                "34",
                "35",
                "36",
                "37",
                "38",
                "39",
                "40",
                "41",
                "42",
                "43",
                "44",
                "45",
                "46",
                "47",
                "48",
                "49",
                "51",
                "52"
            ],
            newCatalogLineBusiness: [{
            "code": "0",
            "value": "TODOS"
        },
        {
            "code": "1",
            "value": "PERSONAS"
        },
        {
            "code": "2",
            "value": "CORPORATIVOS"
        },
        {
            "code": "3",
            "value": "CUENTAS PUBLICAS"
        },
        {
            "code": "4",
            "value": "FIANZAS"
        },
        {
            "code": "5",
            "value": "IFIS"
        },
        {
            "code": "5",
            "value": "AUTOMOTRIZ"
        }
      ],

        }
    }

}
</script>